module.exports = __webpack_public_path__ + "static/media/iconsSvg.af856ec3.svg";